import { useSubscription } from "@apollo/client";
import { Card, Col, Row, Statistic, Typography } from "antd";

import { formatDate } from "@src/utils/dateHelpers";

import { EdgeStateDocument } from "../../graphql/graphql";

const { Text } = Typography;

const CameraHealth = ({ assetId }: { assetId: string }) => {
  const { data, error } = useSubscription(EdgeStateDocument, {
    variables: { assetId },
  });

  if (error) {
    return (
      <Text
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          alignItems: "center",
          height: "100%",
        }}
      >
        Error fetching Camera state: {error.message}
      </Text>
    );
  }

  return (
    <>
      {data?.edgeState.cameraStates.map((camera) => (
        <div key={camera.id} style={{ marginBottom: "20px" }}>
          <Card title={`Camera: ${camera.cameraName}`} bordered={false}>
            <Row gutter={16}>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Last Check At"
                    value={
                      camera.lastCheckAt
                        ? formatDate(camera.lastCheckAt)
                        : "N/A"
                    }
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Stream Accessible"
                    value={camera.streamAccessible ? "Yes" : "No"}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Network Connection"
                    value={
                      camera.networkConnectionPossible
                        ? "Available"
                        : "Not Available"
                    }
                  />
                </Card>
              </Col>
              <Col span={24} style={{ marginTop: 16 }}>
                <Card bordered={false}>
                  <Statistic
                    title="FFprobe Log"
                    value={camera.ffprobeLog || "No logs available"}
                    valueStyle={{
                      fontSize: "14px",
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                    }}
                  />
                </Card>
              </Col>
              <Col span={24} style={{ marginTop: 16 }}>
                <Card bordered={false}>
                  <Statistic
                    title="Netcat Log"
                    value={camera.netcatLog || "No logs available"}
                    valueStyle={{
                      fontSize: "14px",
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                    }}
                  />
                </Card>
              </Col>
            </Row>
          </Card>
        </div>
      ))}
    </>
  );
};

export default CameraHealth;
